<template>
  <div>
    <v-progress-linear
      v-if="isTableBusy"
      indeterminate
      rounded
      color="primary"
    ></v-progress-linear>
    <v-tooltip :disabled="folderRoot == value" top>
      <template v-slot:activator="{ on: tooltip }">
        <span
          class="d-inline-block text-truncate"
          :style="'max-width: '+width+'px;'"
          v-on="{ ...tooltip }"
        >
          {{name}}
        </span>
      </template>
      <span>{{fullPath}}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { folderStoreData } from '../../../catalogs/store/folderStoreHelpers'

export default {
  name: 'DocumentFolder',
  props: {
    value: {
      type: String
    },
    width: {
      type: String
    }
  },
  computed: {
    ...folderStoreData,
    folder() {
      return this.findFolder(this.folders)
    },
    name() {
      return this.folder ? this.folder.nombre : ''
    },
    fullPath() {
      return this.folder ? this.folder.ruta.join('\\') : '' 
    }
  },
  methods: {
    findFolder(fldrs) {
      let folderList = []
      this.pushChildrenFolders(folderList, fldrs)
      
      for(let fldr of folderList)
      {
        if(fldr.idCarpeta == this.value) {
          return fldr
        }
      }
    },
    pushChildrenFolders(folderList, folderChildren)
    {
      for (let fldr of folderChildren) {
        folderList.push(fldr)

        if(fldr.hasOwnProperty('children') && fldr.children.length > 0)
        {
          this.pushChildrenFolders(folderList, fldr.children)
        }
      }
    }
  }
}
</script>